import type { AccessCatalog } from "types/interfaces/access";
import PermissionsPanel from "./PermissionsPanel";
import {
  grantedLines,
  noAccessNames,
  type TierMap,
} from "./permissionsPanelModel";

interface Props {
  catalog: AccessCatalog;
  tiers: TierMap;
  title?: string;
  subHeader?: string;
  /** Which clients the pages show; leave out to say nothing about clients. */
  appliesTo?: string;
  /** Leave out to show nothing about the AI Agent. */
  aiAgent?: boolean;
}

/** What a group grants, rendered from its tiers and the catalog copy. */
export default function AccessGroupPermissionsPanel({
  catalog,
  tiers,
  title = "Access Summary",
  subHeader,
  appliesTo,
  aiAgent,
}: Props) {
  const granted = grantedLines(catalog, tiers);
  const missing = noAccessNames(catalog, tiers);
  if (aiAgent === true) {
    granted.push({
      key: "ai_agent",
      name: catalog.ai_agent.name,
      grants: catalog.ai_agent.grants,
    });
  } else if (aiAgent === false) {
    missing.push(catalog.ai_agent.name);
  }
  return (
    <PermissionsPanel
      title={title}
      subHeader={subHeader}
      appliesTo={appliesTo}
      granted={granted}
      missing={missing}
    />
  );
}
